import { Badge } from "@/components/ui/badge";
import { formatDistanceToNow, format } from "date-fns";
import { PaymentStatusBadge } from "../../components/PaymentStatusBadge";

interface Payment {
  created_at: string;
  amount: number;
  status: string;
  tax_return_requests?: {
    financial_year: string;
    service_type: string;
  };
}

interface RecentPaymentsProps {
  payments: Payment[];
}

export function RecentPayments({ payments }: RecentPaymentsProps) {
  const formatTimestamp = (date: string) => {
    const now = new Date();
    const paymentDate = new Date(date);
    const diffInDays = Math.floor((now.getTime() - paymentDate.getTime()) / (1000 * 60 * 60 * 24));

    if (diffInDays < 7) {
      return formatDistanceToNow(paymentDate, { addSuffix: true });
    }
    return format(paymentDate, 'PPP HH:mm');
  };

  const formatAmount = (amount: number) => {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 2
    }).format(amount);
  };

  const getPaymentReason = (payment: Payment) => {
    if (!payment.tax_return_requests) return "Tax Return";
    return `Online Tax Filing - FY${payment.tax_return_requests.financial_year}`;
  };

  return (
    <div className="mt-6 space-y-2">
      <h4 className="text-sm font-medium">Recent Payments</h4>
      <div className="space-y-1">
        {payments.slice(0, 3).map((payment, index) => (
          <div 
            key={index}
            className="text-sm flex justify-between items-center p-2 rounded bg-muted"
          >
            <div className="flex flex-col gap-1">
              <span className="font-medium">{getPaymentReason(payment)}</span>
              <span className="text-xs text-muted-foreground">
                {formatTimestamp(payment.created_at)}
              </span>
            </div>
            <div className="flex items-center gap-3">
              <span>{formatAmount(payment.amount)}</span>
              <PaymentStatusBadge status={payment.status} />
            </div>
          </div>
        ))}
      </div>
      <a 
        href="/dashboard/payments" 
        target="_blank" 
        rel="noopener noreferrer"
        className="text-sm text-muted-foreground hover:text-foreground flex items-center justify-end mt-2"
      >
        View all payments →
      </a>
    </div>
  );
}